/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationCitiesDropdownQueryResponse,
  GetApiV1LocationCitiesDropdownQueryParams,
  GetApiV1LocationCitiesDropdown401,
  GetApiV1LocationCitiesDropdown500,
} from "../../types/locationCityController/GetApiV1LocationCitiesDropdown.ts";

function getGetApiV1LocationCitiesDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/location/cities/dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna cidades pertencentes ao estado informado (stateId), ordenadas por nome. **(Requer Authorization para autenticação)**
 * @summary Lista de cidades para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities/dropdown}
 */
export async function getApiV1LocationCitiesDropdown(
  params?: GetApiV1LocationCitiesDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationCitiesDropdownQueryResponse,
    ResponseErrorConfig<
      GetApiV1LocationCitiesDropdown401 | GetApiV1LocationCitiesDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationCitiesDropdownUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
